'use strict';

;(function () {
  /* ----- Constants & Variables -----*/
  
  let rechargeManageSubscriptionsInterval, rechargeManageSubscriptionsLink;

  /* ----- Functions & Methods -----*/

  function insertCustomData(){
    const loginBoxContainer = document.querySelector('.login-box');
    const RECHARGE_MANAGE_SUBSCRIPTIONS_T = loginBoxContainer.dataset.manageSubscriptionsT;

    rechargeManageSubscriptionsLink.querySelector('p a').innerText = RECHARGE_MANAGE_SUBSCRIPTIONS_T;
    rechargeManageSubscriptionsLink.classList.add('shown');
  }

  function keepCheckingRechargeLoading(){
    rechargeManageSubscriptionsInterval = setInterval(() => {
      rechargeManageSubscriptionsLink = document.querySelector('#rc_login');
      if(rechargeManageSubscriptionsLink){
        clearInterval(rechargeManageSubscriptionsInterval);
        insertCustomData();
      }
    }, 50);
  }

  /* ----- Events -----*/
  function onDocumentLoaded(){
    keepCheckingRechargeLoading();
  }
  
  if(document.readyState != 'loading'){
    onDocumentLoaded();
  } else {
    document.addEventListener("DOMContentLoaded", onDocumentLoaded);
  }
})();